import { createSlice } from "@reduxjs/toolkit"
const initialState={
    
    currentComments:[],
    
}

const commentSlice=createSlice({
name:'comments',

initialState,
reducers:{
    
    addComments:(state,{payload})=>{
        state.currentComments=[]
        state.currentComments=payload;
        

    },
    deleteAllComments:(state)=>{
        state.currentComments=[];
        

    },
   
    
    

}
})
export const {addComments,deleteAllComments}=commentSlice.actions

export default commentSlice.reducer